













































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
import { getModule } from "vuex-module-decorators";
import LongTrendPeriodModule from "@/store/clients/LongTrendPeriod.module";
import { TrendLimit } from "@/types/trendLimit";

const LongTrendPeriod = getModule(LongTrendPeriodModule, store);

@Component
export default class LimitsCard extends Vue {
  tooltip = "The on board data collection limits met for valid long trend points";

  get limits(): TrendLimit[] {
    return Array.isArray(LongTrendPeriod.trendLimits) ? LongTrendPeriod.trendLimits : []; // Ensure it is always an array
  }

  get reversedLimits(): TrendLimit[] {
    return [...this.limits].reverse(); // Reverse the array for display
  }

  formatDate(date: string | null): string {
    if (!date) return "&mdash;";
    return moment(date).format("D MMM YYYY");
  }

  formatValue(value: number | null, precision: number, fallback: string): string {
    if (value === null || value === undefined) return fallback;
    return this.round(value, precision).toString();
  }

  round(value: number, precision = 1): number {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
}
